/**
 * Created by gocey on 28.08.17.
 */

Box.Application.addModule('sv-tags', function(context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _prepareTags = function() {
        _self.$element = $(context.getElement());
        _self.$filterBtn = _self.$element.find('.button');
        _self.$teaser = _self.$element.find('.facts');
    };

    var _initFilter = function() {
        _self.$element.filter({
            nav: '[data-filter]' // selector for filter nav (optional)
        });
    };

    var _removeTeaser = function() {
        _self.$filterBtn.on('click', function() {
            _self.$teaser.detach();
        })
    };

    return {

        init: function() {
            _prepareTags();
            _initFilter();
            _removeTeaser();
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-tags.js